import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  reportTypeSelection: {
    background: theme.palette.secondary.main,
  },
  mainContent: {
    background: "#fff",
  },
  divider: {
    borderBottom: "solid 1px #C2BDBD",
    padding: 2,
    margin: 2,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  placeholderContent: {
    width: '100%',
    background: 'transparent linear-gradient(1deg, #F0F2F6 0%, #FFFEFE 100%) 0% 0% no-repeat padding-box',
    borderRadius: 10,
    height: '70vh',
    "& button": {
      padding: '10px 24px'
    }
  },
  paraContent: {
    color: '#707E8C',
    margin: '5px 0 20px'
  },
  placeholderImg: {
    width: 100,
    marginBottom: 10,
  },
  previewIndicator: {
    position: "fixed",
    left: 0,
    bottom: 0,
    color: "#fff",
    "& svg": {
      width: 50,
      height: 28
    }
  }
}));

export default useStyles;
